module.exports = __webpack_public_path__ + "img/vip_badge_3.36cd087e.png";